/**
 * Extracts an array from either a bare array or a paginated wrapper object.
 *
 * Some Kubb-generated types declare the response as `T[]` while the actual
 * API returns `{ data: T[], totalCount: number, ... }`. This guard handles
 * both shapes so hooks remain correct at runtime regardless of the mismatch.
 *
 * The overload accepting `T[] | null | undefined` allows TypeScript to infer
 * `T` automatically when the caller passes a typed array from a Kubb hook,
 * avoiding the need for explicit type parameters in every call site.
 */
export function unwrapPagedResponse<T>(raw: T[] | null | undefined): T[];
export function unwrapPagedResponse<T>(raw: unknown): T[];
export function unwrapPagedResponse<T>(raw: unknown): T[] {
  if (Array.isArray(raw)) return raw as T[];
  const paged = raw as { data?: T[] } | undefined;
  return paged?.data ?? [];
}
